import { ProjectRole } from "../types/firestore";

const roleNames: Record<ProjectRole, string> = {
	[ProjectRole.Owner]: "Besitzer",
	[ProjectRole.Admin]: "Administrator",
	[ProjectRole.Driver]: "Fahrer",
};

export default roleNames;
